/**
 * Back-in-Stock-Button -> Klaviyo Back-in-Stock-Modal (von Prestige nach Horizon übernommen; Button sitzt in blocks/add-to-cart.liquid).
 *
 * snippets/buy-buttons.liquid renders a native `.button.w-full` element
 * (`[data-klaviyo-bis-button]`) as the visible CTA for a sold-out variant, alongside the hidden
 * `.klaviyo-bis-trigger` anchor Klaviyo's onsite embed is configured (in the Klaviyo dashboard) to
 * watch for. Live DOM testing confirmed this integration is selector-based, not automatic:
 * removing that anchor made Klaviyo inject nothing at all for the main product form, and
 * re-adding it (even via a plain runtime DOM insertion, no page reload) made Klaviyo immediately
 * inject its own button into `#klaviyo-bis-button-container`. Both elements are hidden via
 * assets/klaviyo-bis.css; this file's only job is forwarding a click on the native button to
 * Klaviyo's real button inside that container, so Klaviyo's own modal, form validation,
 * submission and tracking keep working unmodified - nothing here re-implements or bypasses any of
 * that.
 *
 * Klaviyo injects its container asynchronously (after its own script loads and notices the
 * anchor), while the native button is already visible from server-rendered Liquid, so the button
 * starts `disabled` and a MutationObserver enables it the moment a matching container shows up -
 * this also covers Prestige's AJAX variant switch (see VariantPicker#selectCombination in
 * theme.js, which swaps the whole <product-form> innerHTML and re-renders a fresh, disabled
 * button for the new variant) without needing separate re-init logic: the observer just keeps
 * watching.
 *
 * Plain vanilla JS, kept as its own file (not appended to theme.js) so it survives "Update from
 * Shopify" theme pulls. The click listener is delegated on `document` for the same reason the
 * MutationObserver approach is - it keeps working after any AJAX markup swap without rebinding.
 */
(() => {
  "use strict";

  const BUTTON_SELECTOR = "[data-klaviyo-bis-button]";
  const KLAVIYO_CONTAINER_SELECTOR = "#klaviyo-bis-button-container";

  function findKlaviyoButton(nativeButton) {
    const scope = nativeButton.closest("product-form-component") || nativeButton.closest("product-form") || nativeButton.closest("form") || nativeButton.closest(".shopify-section") || document;
    return scope.querySelector(`${KLAVIYO_CONTAINER_SELECTOR} button`);
  }

  function activateReadyButtons(root) {
    root.querySelectorAll(`${BUTTON_SELECTOR}[disabled]`).forEach((nativeButton) => {
      if (findKlaviyoButton(nativeButton)) {
        nativeButton.disabled = false;
      }
    });
  }

  activateReadyButtons(document);

  new MutationObserver(() => activateReadyButtons(document)).observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener("click", (event) => {
    const nativeButton = event.target.closest(BUTTON_SELECTOR);
    if (!nativeButton || nativeButton.disabled) return;

    const klaviyoButton = findKlaviyoButton(nativeButton);
    if (klaviyoButton) {
      klaviyoButton.click();
    } else {
      console.warn("[klaviyo-bis] Klaviyo Back-in-Stock ist gerade noch nicht bereit.");
    }
  });
})();
